import { render, staticRenderFns } from "./EdicionPtiCambiarTratamiento.vue?vue&type=template&id=5782214e&scoped=true"
import script from "./EdicionPtiCambiarTratamiento.vue?vue&type=script&lang=js"
export * from "./EdicionPtiCambiarTratamiento.vue?vue&type=script&lang=js"
import style0 from "./EdicionPtiCambiarTratamiento.vue?vue&type=style&index=0&id=5782214e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782214e",
  null
  
)

export default component.exports